<template>
  <div class="hero min-h-full relative overflow-hidden">
    <div class="absolute inset-0 opacity-10 pointer-events-none">
      <i class="mdi mdi-trending-up absolute top-1/3 lg:top-24 left-6 text-8xl lg:text-9xl text-base-content -rotate-6 hidden sm:block"></i>
      <i class="mdi mdi-medal-outline absolute top-20 right-8 text-7xl lg:text-8xl text-base-content rotate-12 hidden sm:block"></i>
      <i class="mdi mdi-medal-outline absolute bottom-14 left-24 text-8xl lg:text-9xl text-base-content -rotate-6"></i>
      <i class="mdi mdi-podium-gold absolute bottom-1/3 right-12 text-8xl lg:text-9xl text-base-content/90 rotate-8 hidden md:block"></i>
    </div>

    <div class="hero-content pt-16 sm:pt-20 lg:pt-0 text-center text-base-content relative z-10">
      <div class="max-w-5xl grid lg:grid-cols-2 gap-10 items-center">
        <div class="text-left flex flex-col gap-4">
          <div class="flex items-center gap-3">
            <i class="mdi mdi-trophy-outline text-5xl text-base-content/50"></i>
            <h1 class="text-5xl font-bold">Stock Jockey</h1>
          </div>
          <p class="text-sm opacity-70 rounded-lg py-2">
            <FlipValue :display="activeSlogan" :value-key="sloganIndex" />
          </p>
          <div class="rounded-lg bg-white/10">
            <div class="flex items-center gap-1">
              <div
                v-for="(color, idx) in [...PORTFOLIO_PALETTE].reverse()"
                :key="`pos-${idx}`"
                class="h-4 flex-1 rounded-sm border border-base-content/10"
                :style="{ backgroundColor: color }"
              ></div>
            </div>
          </div>
          <p class="text-lg opacity-90 leading-relaxed">
            The easy-going paper trading competition platform for <strong>everyone</strong>.
          </p>

          <NewsletterSignup />
        </div>

        <LiveLeaderboardTile />
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, onBeforeUnmount, onMounted, ref } from 'vue'
import FlipValue from '../components/FlipValue.vue'
import LiveLeaderboardTile from '../components/LiveLeaderboardTile.vue'
import NewsletterSignup from '../components/NewsletterSignup.vue'
import { PORTFOLIO_PALETTE } from '../lib/apexTheme.js'

const SLOGAN_CYCLE_MS = 5000
const slogans = [
  'No Stakes. Full Stakes Energy.',
  'Zero Risk. Maximum Flex.',
  'Paper Trades. Real Bragging Rights.',
  'Test Your Thesis. Top the Table.',
]
const sloganIndex = ref(0)
const activeSlogan = computed(() => slogans[sloganIndex.value] ?? slogans[0])
let sloganTimer = null

onMounted(() => {
  sloganTimer = window.setInterval(() => {
    sloganIndex.value = (sloganIndex.value + 1) % slogans.length
  }, SLOGAN_CYCLE_MS)
})

onBeforeUnmount(() => {
  if (sloganTimer) {
    window.clearInterval(sloganTimer)
    sloganTimer = null
  }
})
</script>
